import { Link } from "react-router-dom";

const NotLoggedIn = () => {
  return (
    <div className="container mx-auto text-center p-5">
      <div className="w-full rounded-lg bg-red-100 border border-red-400 text-red-700 font-bold px-4 py-3">
        يجب تسجيل الدخول أولاً، اضغط{" "}
        <Link
          to="/"
          className="inline-block px-4 py-2 mx-1 font-bold bg-primary text-white rounded hover:bg-primary/90 transition"
        >
          هنا
        </Link>{" "}
        للذهاب للصفحة الرئيسية
      </div>
    </div>
  );

  // return (
  //   <div className="container text-center p-5 m-auto">
  //     <div className="alert alert-danger fw-bold rounded-ea w-100" role="alert">
  //       يجب تسجيل الدخول أولاً , إضغط{" "}
  //       <Link to="/" className="px-2 py-0 mx-1 fw-bold btn ea-btn">
  //         هنا
  //       </Link>{" "}
  //       للذهاب للصفحة الرئيسية
  //     </div>
  //   </div>
  // );
};

export default NotLoggedIn;
